export { getTickValues, getNiceTickValues, getTickValuesFixedDomain } from './getNiceTickValues';


//////////////////
// WEBPACK FOOTER
// ./~/recharts-scale/es6/index.js
// module id = ./node_modules/recharts-scale/es6/index.js
// module chunks = 1